<template>
  <div class="append-box" @touchmove="gtouchmove">
    <v-mask style="background:none;"></v-mask>
    <div
      v-bind:class="{'append-box-content animated baisonFadeInDown message-box':true,'baisonFadeInUp':fadeOut}"
    >
      <btnClose class="close-pop-message" v-show="showCloseBtn" @close="handleClose"></btnClose>
      <div class="message-content-box" ondragstart="return false;">
        <p class="messageTxt">{{content}}</p>
      </div>
      <btn @click="handleConfirm" class="pop-message-btn" v-bind:text="confirmText"></btn>
    </div>
  </div>
</template>

<script>
import vmask from "@/components/mask.vue";
import btnClose from "@/components/btnClose.vue";
import btn from "@/components/btn.vue";
export default {
  name: "message",
  components: {
    "v-mask": vmask,
    btnClose,
    btn,
  },
  data() {
    return {
      fadeOut: false,
      content: "当前网络不好！请重新下载~",
      confirmText: "重新下载",
      confirmClose: true,
      showCloseBtn: false,
      confirmCallback: null,
      closeCallback: null,
    };
  },
  methods: {
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    remove() {
      this.fadeOut = true;
      setTimeout(() => {
        this.$el.parentNode.removeChild(this.$el);
        this.$destroy(true);
        this.fadeOut = false;
      }, 300);
    },
    handleClose() {
      this.remove();
      if (typeof this.closeCallback == "function") {
        this.closeCallback();
      }
    },
    handleConfirm() {
      if (this.confirmClose) {
        this.remove();
      }
      if (typeof this.confirmCallback == "function") {
        this.confirmCallback();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.append-box {
  z-index: 999999999;
  .message-box {
    -webkit-animation-duration: 0.3s;
    animation-duration: 0.3s;
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    z-index: 301;
    color: #ffffff;
    height: 1.55rem;
    width: 3.45rem;
    margin-left: -1.725rem;
    margin-top: -0.775rem;
    background: url(~@/assets/img/UI_common_frame_03.png) no-repeat;
    background-size: cover;
    font-size: 0.12rem;
    .message-content-box {
      height: 0.89rem;
      width: 3.115rem;
      margin: 0.15rem 0.15rem 0 0.15rem;
      background: url(~@/assets/img/UI_common_frameU_01.png) no-repeat;
      background-size: cover;
      text-align: center;
      font-size: 0.12rem;
      position: relative;
      .messageTxt {
        margin: 0;
        padding: 0;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        width: 2.5rem;
        text-align: center;
        word-break: break-all;
      }
    }
    .pop-message-btn {
      margin-top: 0.05rem;
    }
    .close-pop-message {
      position: absolute;
      right: -0.09rem;
      top: -0.09rem;
    }
  }
}
</style>